import { render } from "./fan_letter_like_button.vue?vue&type=template&id=31027f98"
import script from "./fan_letter_like_button.vue?vue&type=script&lang=js"
export * from "./fan_letter_like_button.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__